import React, {LegacyRef, memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {useTemplatedComponent} from "@next/templating"
import {MobileThumbnailConfig} from "../../../../models/ProductSummary"
import connect from "./connect"
import {AdditionalColourchipsLoadingState} from "../../../../models/AdditionalColourchipsLoadingState"

interface ColourChip {
    itemNumber: string
    colourChipUrl: string
    linkUrl: string
    isSelected?: boolean
    colour?: string | null
    title: string
    price: string
    currencyCode: string
    altText: string
    department: string
}

export interface ThumbsSwiperCarouselProps {
    template: {mainTemplate: string; fallbackTemplate: string}
    colourchips: ColourChip[]
    lazyloadColourchips?: boolean
    mobileThumbnailConfig?: MobileThumbnailConfig
    numberOfAllColourways: number
    fetchAdditionalColourchipsThunk: () => void
    textAlignment: string
    setAdditionalColourchipsLoading: (boolean) => void
    additionalColourchipsLoading: AdditionalColourchipsLoadingState
    thumbsEmblaRef: LegacyRef<HTMLDivElement> | undefined
    thumbsSlideIndex: (index: number) => void
    slideIndex: (index: number) => void
}

export const ThumbsSwiperCarousel = memo(
    ({
        template,
        colourchips,
        lazyloadColourchips,
        mobileThumbnailConfig,
        numberOfAllColourways,
        fetchAdditionalColourchipsThunk,
        textAlignment,
        setAdditionalColourchipsLoading,
        additionalColourchipsLoading,
        thumbsEmblaRef,
        thumbsSlideIndex,
        slideIndex,
    }: ThumbsSwiperCarouselProps) => {
        const ComponentName = useTemplatedComponent(template, MANIFEST)

        const props = {
            colourchips,
            mobileThumbnailConfig,
            numberOfAllColourways,
            fetchAdditionalColourchipsThunk,
            lazyloadColourchips,
            textAlignment,
            setAdditionalColourchipsLoading,
            additionalColourchipsLoading,
            thumbsEmblaRef,
            thumbsSlideIndex,
            slideIndex,
        }
        return <ComponentName {...props} />
    },
)
ThumbsSwiperCarousel.displayName = "ThumbsSwiperCarousel"

export default connect(ThumbsSwiperCarousel)
